export default {
    methods: {
        /**
         * 大数据统计
         * @param bigData 大数据键名
         * @param thirdParty 第三方键名
         * @param data 字符串数据
         */
        $bigData(bigData, thirdParty, data) {
            return new Promise(resolve => {
                console.log(`%c ${bigData} %c ${thirdParty} %c ${data} `,
                    'background: #35495e;padding: 1px;border-radius: 3px 0 0 3px;color: #fff',
                    'background: #409eff;padding: 1px;border-radius: 0;color: #fff',
                    'background: #41b883;padding: 1px;border-radius: 0 3px 3px 0;color: #fff'
                );
                // bigData=大数据键名
                // thirdParty=第三方统计键名
                // data=数据

                const bigData_json = `${bigData}=${String(data)}`;// 大数据JSON
                // 发送数据时间
                const bigData_endTime = new Date().getTime();
                // 大数据发送
                this.$ajax({
                    url: '/HandlerBD.ashx',
                    autoCancel: false,
                    bigData: false,
                    data: {
                        act: 'bigData',
                        bigDataUser: this.$getCookie('cookieName') || '',// 用户名
                        bigDataUrl: window.location.pathname.toLowerCase(),// 获取路由路径
                        bigDataAllUrl: window.location.href.toLowerCase(),// 获取完整路径
                        bigDataNav: navigator.userAgent,// 浏览器信息
                        bigDataJson: bigData_json,// 大数据JSON
                        bigDataFirstTime: this.$store.state.bigData_firstTime,// 进入当前页面的时间
                        bigDataTime: bigData_endTime - this.$store.state.bigData_startTime// 距离上一次发送间隔时间
                    },
                    complete: () => {
                        resolve();
                    }
                });
                // 发送完毕
                this.$store.commit('bigDataStartTime', bigData_endTime);
            });
        }
    }
};